import React, {useLayoutEffect, useMemo} from 'react';
import {PromocodePropsInterface} from "@/views/Admin/Events/Event/Promocodes/Promocode/Promocode.props.interface";
import {Button, Checkbox, Select, Tag, useToast} from "uikit";
import DotsIcon from 'uikit/src/assets/icons/16/dots.svg'
import CertificateIcon from '@/assets/images/icons/16/award.svg'
import CopyIcon from '@/assets/images/icons/12/copy.svg'
import styles from './Promocode.module.scss'
import table from '@/views/Admin/Events/Event/Promocodes/Table/Table.module.scss'
import GearIcon from "@/assets/images/icons/12/gear.svg";
import {useLocation} from "react-router-dom";
import {useQueryRouter} from "@/hooks/useQueryRouter/useQueryRouter";

const Promocode = ({data, onChange, onRemove, onEdit, onActive}: PromocodePropsInterface) => {
    const {search} = useLocation();
    const params = useMemo(() => new URLSearchParams(search), [search]);
    const {query, set} = useQueryRouter()
    const id = Number(params.get('id'));
    const toast = useToast();

    useLayoutEffect(() => {
        if (String(id) === String(data.id)) {
            onEdit(data)
        }
    }, [query?.id])

    const handleActive = () => {
        onActive(data)
    }

    const handleRemove = () => {
        onRemove([data])
    }

    const handleEdit = async () => {
        set({id: data.id})
    }

    const handleDuplicate = async () => {
        set({id: -1})
        await onEdit({...data, hash: null})
    }

    const handleCopy = () => {
        navigator.clipboard.writeText(data.promocode).then(() => {
            toast({type: 'success', message: `Промокод «${data.promocode}» скопирован`});
        }).catch((err) => {
            console.error('Ошибка копирования:', err);
        });
    };

    const formatDateRange = (from?: string | null, till?: string | null) => {
        if (from && till) {
            return `${new Date(from).toLocaleDateString()} – ${new Date(till).toLocaleDateString()}`;
        }
        if (from) {
            return `с ${new Date(from).toLocaleDateString()}`;
        }
        if (till) {
            return `до ${new Date(till).toLocaleDateString()}`;
        }
        return '–';
    };

    return (
        <div className={[table.row, styles.container].filter(Boolean).join(' ')}>
            <div className={table.cell} data-label="Промокод">
                <div className={table.checkbox}>
                    <Checkbox
                        value={data.isActive}
                        onChange={handleActive}>
                        <p>
                            {data.promocode}
                        </p>
                    </Checkbox>
                    {data.isCertificate && <Tag
                        size={'xsmall'}
                        type={'warning'}>
                        <CertificateIcon/>
                    </Tag>}
                    <Button
                        title={'Копировать'}
                        type={'secondary'}
                        size={'xxsmall'}
                        theme={'ghost'}
                        onClick={handleCopy}
                        className={[styles.button, styles.copy].filter(Boolean).join(' ')}>
                        <CopyIcon/>
                    </Button>
                </div>
            </div>
            <div className={table.cell} data-label="Группа">
                <p>
                    {data.promocodeGroup?.name || '–'}
                </p>
            </div>
            <div className={table.cell} data-label="События">
                <p>
                    {data.event.eventTitle || '–'}
                </p>
            </div>
            <div className={table.cell} data-label="Использовано">
                <p>
                    <strong>{Number(data.used)}</strong> из {data.count ?? '∞'}
                </p>
            </div>
            <div className={table.cell} data-label="Старт – Окончание">
                <p>{formatDateRange(data.from, data.till)}</p>
            </div>
            <div className={table.cell} data-label="Скидка">
                <p>
                    {data.typeId === 'fixed' && new Intl.NumberFormat('ru-RU', {
                        style: 'currency',
                        currency: 'RUB',
                        minimumFractionDigits: 0
                    }).format(Number(data.size))}
                    {data.typeId === 'percent' && `${Number(data.size)}%`}
                </p>
            </div>
            <div className={table.cell}>
                <div className={styles.action}>
                    <div className={styles.select}>
                        <Button
                            type={'secondary'}
                            theme={'ghost'}
                            className={styles.button}
                            onClick={handleEdit}>
                            <GearIcon/>
                        </Button>
                    </div>
                    <div className={styles.select}>
                        <Select
                            direction={['bottom', 'left']}
                            onChange={() => null}
                            data={[
                                <div
                                    className={styles.item}
                                    onClick={handleDuplicate}>
                                    Создать копию
                                </div>,
                                <div
                                    className={styles.item}
                                    onClick={handleRemove}>
                                    Удалить промокод
                                </div>,
                            ]}>
                            <Button
                                type={'secondary'}
                                theme={'ghost'}
                                className={styles.button}>
                                <DotsIcon/>
                            </Button>
                        </Select>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Promocode;
